<template>
  <img
    :src="Logo"
    alt=""
    class="rounded-lg"
    :class="
      size === 'sm'
        ? 'w-12 h-12'
        : size === 'md'
        ? 'w-24 h-24'
        : size === 'xl'
        ? 'w-48 h-48'
        : 'w-32 h-32'
    "
  />
</template>

<script setup lang="ts">
import Logo from '@/assets/logo.png'

withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg' | 'xl'
  }>(),
  {
    size: 'md'
  }
)
</script>
